import { Routes, Route, useNavigate, useLocation } from "react-router-dom";
import { Page } from "./types";
import ScrollToTop from "./ScrollToTop";
import Footer from "designs/DesignA/components/Footer/Footer";
import Page404 from "designs/DesignA/containers/Page404/Page404";
import ListingCarPage from "designs/DesignA/containers/ListingCarPage/ListingCarPage";

import PageContact from "designs/DesignA/containers/PageContact/PageContact";
import SiteHeader from "designs/DesignA/containers/SiteHeader";
import PageHome from "designs/DesignA/containers/PageHome/PageHome";
import AvailableCarsPage from "designs/DesignA/containers/AvailableCarsPage/AvailableCarsPage";
import ListingCarDetailPage from "designs/Common/ListingDetailPage/listing-car-detail/ListingCarDetailPage";
import CarListingCarDetailPage from "designs/Common/CarListingDetailPage/CarListingDetailPage";
import CheckOutPagePageMain from "designs/Common/CheckOutPage/CheckOutPage";
import PrivacyPolicy from "designs/Common/CheckOutPage/PrivacyPolicy";
import PayLaterPoliciesPage from "designs/Common/PayLaterPoliciesPage/PayLaterPoliciesPage";
import BookingDetailPage from "designs/Common/BookingDetailsPage/BookingDetailsPage";
import PaymentSuccess from "designs/Common/PaymentSuccess/PaymentSuccess";
import PageAbout from "designs/DesignA/containers/PageAbout/PageAbout";
import { useEffect, useRef } from "react";
import { useData } from "data/data-provider";

export const pages: Page[] = [
  { path: "/", exact: true, component: PageHome },
  { path: "/home", component: PageHome },
  { path: "/available-car", component: AvailableCarsPage },
  { path: "/vehicles", component: ListingCarPage },
  { path: "/booking-details", component: BookingDetailPage },
  { path: "/payment-success", component: PaymentSuccess },
  { path: "/listing-car-detail", component: ListingCarDetailPage },
  { path: "/checkout", component: CheckOutPagePageMain },
  { path: "/privacy-policy", component: PrivacyPolicy },
  { path: "/contact", component: PageContact },
  { path: "/car-listing-detail", component: CarListingCarDetailPage },
  { path: "/about", component: PageAbout },
  { path: "/pay-later-policies", component: PayLaterPoliciesPage },
];

const DesignARouter = () => {
  const hasScrolled = useRef(false);
  const { aboutUs, whyUs, testimonials, faqs, ourVehicles, popUp } = useData();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const hash = location.hash;

    if (
      hash &&
      hash.length > 1 &&
      !location.pathname.includes("loading") &&
      !hasScrolled.current
    ) {
      setTimeout(() => {
        const element = document.querySelector(hash);
        if (element) {
          element.scrollIntoView({ behavior: "smooth" });
          setTimeout(() => {
            navigate(location.pathname, { replace: true });
            hasScrolled.current = true;
          }, 1000);
        }
      }, 500);
    }
    if (!hash) {
      hasScrolled.current = false;
    }
  }, [
    location.hash,
    location.pathname,
    navigate,
    aboutUs,
    whyUs,
    testimonials,
    faqs,
    ourVehicles,
  ]);

  return (
    <>
      <ScrollToTop />
      <SiteHeader />

      <Routes>
        {pages.map(({ component, path }) => {
          const Component = component;
          return <Route key={path} element={<Component />} path={path} />;
        })}
        <Route path="*" element={<Page404 />} />
      </Routes>
      <div id="section-footer">
        <Footer />
      </div>
    </>
  );
};

export default DesignARouter;
